<template>
    <div class="left abs">
        <div class="list cp" :class="{current:$route.name=='editImg'}" @click="to('editImg')">
            <img :src="imgUrlA()" alt>
            <p>图片编辑</p>
        </div>
        <div class="list cp" :class="{current:$route.name=='transform'}" @click="to('transform')">
            <img :src="imgUrlB()" alt>
            <p>格式转换</p>
        </div>
        <div class="list cp" :class="{current:$route.name=='compress'}" @click="to('compress')">
            <img :src="imgUrlC()" alt>
            <p>图片压缩</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Left',
    methods: {
        imgUrlA() {
            let path = 'img/menu/btn_editImg0'
            return this.$route.name == 'editImg' ? path + '2.png' : path + '1.png';
        },
        imgUrlB() {
            let path = 'img/menu/btn_transform0'
            return this.$route.name == 'transform' ? path + '2.png' : path + '1.png';
        },
        imgUrlC() {
            let path = 'img/menu/btn_compress0'
            return this.$route.name == 'compress' ? path + '2.png' : path + '1.png';
        },
        to(path) {
            let _this = this;
            var eu = window.editorUrls;
            switch (path) {
                case 'editImg':


                    /*
                        if (_this.$route.name != 'editImg') {
                            //其他两个页面也有文件列表 ★
                            this.$router.push({
                                name: 'editImg'
                            });
                        }*/

                    if (_this.$route.name != 'editImg') {
                        if (eu && eu.length > 0) {
                            window.picAction = 'editImg';
                            window.tuiHint.show();
                        } else {
                            this.$router.push({
                                name: 'editImg'
                            });
                        }
                    }

                    break;
                case 'transform':
                    if (_this.$route.name != 'transform') {
                        if (eu && eu.length > 0) {
                            window.picAction = 'transform';
                            window.tuiHint.show();
                        } else {
                            this.$router.push({
                                name: 'transform'
                            });
                        }
                    }
                    break;
                case 'compress':
                    if (_this.$route.name != 'compress') {
                        if (eu && eu.length > 0) {
                            window.picAction = 'compress';
                            window.tuiHint.show();
                        } else {
                            this.$router.push({
                                name: 'compress'
                            });
                        }
                    }
                    break;
            }
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.left {
    top: 41px;
    bottom: 1px;
    width: 114px;
    background-color: #333d4b;
}

.list {
    height: 110px;
    color: #758192;
}

.list.current {
    background-color: #2d3744;
    border-right: solid 5px #0090ff;
    color: #bbc6db;
}

.list img {
    padding: 17px 0px 0px 35px;
}

.list p {
    padding: 10px 0px 0px 27px;
    font-size: 14px;
}
</style>
